const formatter = (currency = 'UAH', options) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    ...options,
});

export const formatMoney = (amount, currency = 'UAH', options = {}) => formatter(currency, options).format(amount);

export const formatDate = (date) => {
    if (!!!date) {
        return "–"
    }
    return "".concat(
        date.substring(6, 10),
        date.substring(2, 6),
        date.substring(0, 2)
    ).replaceAll('.', '-');
}
